<template>
  <v-container fluid>
    <div class="title primary--text mb-2">{{$t('Equipments')}}</div>
    <!-- <v-btn absolute fab top right color="primary" class="mt-3" @click.stop="showDialog=true">
      <v-icon>mdi-plus</v-icon>
    </v-btn> -->
    <v-layout wrap>
      <v-flex mb-4 mr-2 xs12 sm6 lg4 v-for="(e, index) in equipments" v-bind:key="index">
        <EquipmentPanel v-bind:equipIndex="index" />
      </v-flex>
    </v-layout>
    <!-- <span class="subtitle-1 mt-6 teal--text">
      {{$t('To activate_additional equipment, follow the instructions in the tablet app')}}
    </span> -->
  </v-container>
</template>

<script>
import EquipmentPanel from "../components/EquipmentPanel";
export default {
  data: function () {
    return {
    }
  },
  components: {
    EquipmentPanel
  },
  created() {
    this.$store.dispatch("loadEquipments");
  },
  computed: {
    equipments() {
      return this.$store.getters.getEquipmentList;
    }
  },
}
</script>

<style>

</style>